<ng-container *ngIf="{ selectBreadcrumbs: selectBreadcrumbs$ | async } as data">
  <div class="flex-row w-100 h-100 root-content-wrapper">
    <app-sidebar></app-sidebar>
    <div class="w-100 flex-col main-content">
      <ui-header-with-breadcrumbs
        [selectBreadcrumbs]="data.selectBreadcrumbs || []"
      ></ui-header-with-breadcrumbs>
      <div class="page-content flex">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</ng-container>
